import type { CreateMainGroupDto, CreateMainGroupVisitDto, MainGroupDto, MainGroupVisitDto, UpdateMainGroupDto, UpdateMainGroupVisitDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MainGroupService {
  apiName = 'Default';
  

  create = (input: CreateMainGroupDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupDto>({
      method: 'POST',
      url: '/api/app/main-group',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  createVisit = (input: CreateMainGroupVisitDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupVisitDto>({
      method: 'POST',
      url: '/api/app/main-group/visit',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/main-group/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteVisit = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/main-group/${id}/visit`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupDto>({
      method: 'GET',
      url: `/api/app/main-group/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/main-group/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      url: '/api/app/main-group/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupDto[]>({
      method: 'GET',
      url: `/api/app/main-group/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      url: `/api/app/main-group/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/app/main-group/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<MainGroupDto>>({
      method: 'GET',
      url: '/api/app/main-group',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/main-group/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      url: '/api/app/main-group/schema',
    },
    { apiName: this.apiName,...config });
  

  getVisitsByMainGroupId = (mainGroupId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupVisitDto[]>({
      method: 'GET',
      url: `/api/app/main-group/visits-by-main-group-id/${mainGroupId}`,
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupDto>({
      method: 'GET',
      url: `/api/app/main-group/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/main-group/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateMainGroupDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupDto>({
      method: 'PUT',
      url: `/api/app/main-group/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateVisit = (id: string, input: UpdateMainGroupVisitDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MainGroupVisitDto>({
      method: 'PUT',
      url: `/api/app/main-group/${id}/visit`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
